import { Plus } from "lucide-react";
import { ymd, fmt, itemsForDay, todayStr } from "@/lib/dates";
import { ShiftChip, TaskChip, HolidayChip } from "@/components/calendar/Chips";

const DayColumn = ({ day, data, userId, onSelect, onAdd, wide }) => {
  const mine = itemsForDay(data, day, userId);
  const othersOff = data.holidays.filter((h) => h.user_id !== userId && h.start_date <= day && h.end_date >= day);
  const isToday = day === todayStr();
  return (
    <div className={`flex flex-col md:min-h-[220px] ${wide ? "" : "md:min-w-[140px]"}`} data-testid={`day-column-${day}`}>
      <div className={`group/head flex items-start justify-between px-3 py-2.5 border-b ${isToday ? "bg-[#24474A] text-white" : "bg-slate-50/70 text-slate-700"}`}>
        <div className="flex items-baseline gap-2 md:block">
          <div className="text-[11px] uppercase tracking-[0.15em] opacity-80">{fmt(day, "EEE")}</div>
          <div className="text-xl font-bold">{fmt(day, "d")}</div>
        </div>
        <button type="button" onClick={() => onAdd(day)} title="Add task" data-testid={`day-add-task-${day}`} className={`w-7 h-7 rounded-full grid place-items-center transition-colors ${isToday ? "hover:bg-white/15" : "hover:bg-[#EAF2F2] text-[#24474A]"}`}>
          <Plus className="w-4 h-4" />
        </button>
      </div>
      <div className="flex-1 p-2 space-y-1.5 cursor-copy hover:bg-slate-50/60 transition-colors" onClick={(e) => e.target === e.currentTarget && onAdd(day)} data-testid={`day-body-${day}`}>
        {mine.holidays.map((h) => <HolidayChip key={h.id} holiday={h} showName={false} onClick={() => onSelect({ kind: "holiday", item: h })} />)}
        {mine.shifts.map((s) => <ShiftChip key={s.id} shift={s} onClick={() => onSelect({ kind: "shift", item: s })} />)}
        {mine.tasks.map((t) => <TaskChip key={t.id} task={t} onClick={() => onSelect({ kind: "task", item: t })} />)}
        {othersOff.length > 0 && (
          <div className="pt-1 space-y-1">
            {othersOff.map((h) => <HolidayChip key={h.id} holiday={h} onClick={() => onSelect({ kind: "holiday", item: h })} />)}
          </div>
        )}
        {!mine.shifts.length && !mine.tasks.length && !mine.holidays.length && (
          <div className="text-[11px] text-slate-400 px-1 pt-1 pointer-events-none">No shift · click to add a task</div>
        )}
      </div>
    </div>
  );
};

export const PersonalView = ({ days, data, userId, onSelect, onAdd }) => (
  <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white shadow-[0_1px_0_rgba(15,23,42,0.03)]" data-testid="personal-calendar">
    <div className={`grid divide-y md:divide-y-0 md:divide-x divide-slate-100 ${days.length === 1 ? "grid-cols-1" : "grid-cols-1 md:grid-cols-7 md:min-w-[980px]"}`}>
      {days.map((d) => <DayColumn key={ymd(d)} day={ymd(d)} data={data} userId={userId} onSelect={onSelect} onAdd={onAdd} wide={days.length === 1} />)}
    </div>
  </div>
);
